const configuredPlatformApiUrl = import.meta.env.VITE_API_URL || '/api';

export const PLATFORM_API_URL = configuredPlatformApiUrl.replace(/\/+$/, '') || '/api';

export function getPlatformApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${PLATFORM_API_URL}${normalizedPath}`;
}

export function platformFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(getPlatformApiUrl(path), init);
}
